










import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({})
export default class ScheduleNotificationToggle extends Vue {
  @Prop({ default: false }) readonly value!: boolean;
  localValue: boolean = this.value;

  scheduleNotification: { text: string; value: boolean }[] = [
    {
      text: "する",
      value: true
    },
    {
      text: "しない ",
      value: false
    }
  ];

  @Watch("value", { immediate: true })
  onValueChanged(newVal: boolean) {
    this.localValue = newVal;
  }

  @Watch("localValue")
  onLocalValueChanged(newVal: boolean) {
    this.$emit("input", newVal);
  }
}
